const pubsub = require('../utils/pubsub');

/**
 * subscribe all listed hooks in the config
 */
function init(hooks) {
	Object.keys(hooks).forEach((hook) => {
		pubsub.subscribe(hook, hooks[hook]);
	});

	_setLegacyHooks(hooks);
}

function _setLegacyHooks(hooks) {
	window.dfp = window.dfp || {};

	Object.keys(hooks).forEach((hook) => {
		if (typeof window.dfp[hook] === 'undefined') {
			window.dfp[hook] = _createLegacyHook(hook);
		}
	});
}

function _createLegacyHook(hook) {
	return (...args) => {
		pubsub.publish(hook, ...args);
	};
}

module.exports = {
	init
};
